import { useState, useCallback, useMemo ,useEffect} from 'react';
import { useRequest } from 'ahooks';
import { getSavedFoldList } from '../axios/api'
import util from '../utils/utils';

function useGetSavedFoldList(props){
    const { loading, data, run } = useRequest(
        async () => {
          const clientId = util.getCurrentClientId();
          
          // ✅ a环境：确保有用户信息并强制执行
          if (clientId === 'client-a') {
            const userInfo = util.ensureUserInfo();
            
            // a环境直接执行，不再检查登录状态
            try {
              const userId = util.getUserId();
              const params = userId ? { user_id: userId } : {};
              
              const resp = await getSavedFoldList(params);
              let foldList = resp?.data?.fold_list
              return foldList ?? [];
            } catch (error) {
              return [];
            }
          }
          
          // ✅ b环境：检查登录状态
          if (!util.isUserLoggedIn()) {
            return [];
          }
          
          try {
            const userId = util.getUserId();
            const params = userId ? { user_id: userId } : {};
            
            const resp = await getSavedFoldList(params);
            let foldList = resp?.data?.fold_list
            return foldList ?? [];
          } catch (error) {
            console.error('b环境获取收藏夹列表失败:', error);
            return [];
          }
        },
        {
          refreshDeps: [],
          debounceWait: 300,
          retryCount: 1,
          cacheKey: 'saved_fold_list',
          manual: true,  // 保持手动触发
        }
    );
    
    // 组件挂载时检查登录状态并触发请求
    useEffect(() => {
        const clientId = util.getCurrentClientId();
        
        
        if (clientId === 'client-a') {
            // a环境：确保用户信息并直接执行
            util.ensureUserInfo();
            
            // 添加小延迟确保用户信息已设置
            setTimeout(() => {
                run();
            }, 100);
        } else if (util.isUserLoggedIn()) {
            // b环境：只有登录时才执行
            run();
        } else {
        }
    }, []);
    
    const savedFoldListRefresh = () => {
      const clientId = util.getCurrentClientId();
      
      
      if (clientId === 'client-a') {
        // a环境：确保用户信息并执行
        util.ensureUserInfo();
        setTimeout(() => {
            run();
        }, 50);
      } else if (util.isUserLoggedIn()) {
        // b环境：只有登录时才执行
        run();
      }
    };

    return {
      savedFoldListLoading: loading,
      savedFoldListData: data || [], // 确保始终返回数组
      savedFoldListRefresh,
    }
}

export default useGetSavedFoldList